const stopEventPropagation = (event) => {
    event.stopPropagation();
    event.cancelable = true;
}

export default stopEventPropagation